import axios from '@/utils/axios'

export default async function GetBySlug(slug: string, currency: string, country:string) {
  const {data} = await axios.get(
    process.env.NEXT_PUBLIC_API_URL + '/products/product/' + slug + '?currency=' + currency + '&country=' + country,
  )
  return data
}

export async function GetBySlugQuery({queryKey}: any) {
  const {data} = await axios.get(
    process.env.NEXT_PUBLIC_API_URL + '/products/product/' + queryKey[1],
  )
  return data
}
